import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const CaretUp = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M8.0386 14.1372c-.1699 0-.3076-.0579-.4133-.1739-.1057-.1159-.1585-.2485-.1585-.3978 0-.0413.058-.1739.174-.3978l3.7625-3.7624c.0913-.0914.1857-.1557.283-.193A.8673.8673 0 0112 9.1563c.112 0 .2166.0186.3138.056.0973.0373.1917.1016.283.193l3.7625 3.7624c.058.058.1015.1201.1305.1863a.522.522 0 01.0435.2115c0 .1493-.0528.2819-.1585.3978-.1057.116-.2434.1739-.4133.1739h-7.923z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M8.0386 14.1372c-.1699 0-.3076-.0579-.4133-.1739-.1057-.1159-.1585-.2485-.1585-.3978 0-.0413.058-.1739.174-.3978l3.7625-3.7624c.0913-.0914.1857-.1557.283-.193A.8673.8673 0 0112 9.1563c.112 0 .2166.0186.3138.056.0973.0373.1917.1016.283.193l3.7625 3.7624c.058.058.1015.1201.1305.1863a.522.522 0 01.0435.2115c0 .1493-.0528.2819-.1585.3978-.1057.116-.2434.1739-.4133.1739h-7.923z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M8.0386 14.1372c-.1699 0-.3076-.0579-.4133-.1739-.1057-.1159-.1585-.2485-.1585-.3978 0-.0413.058-.1739.174-.3978l3.7625-3.7624c.0913-.0914.1857-.1557.283-.193A.8673.8673 0 0112 9.1563c.112 0 .2166.0186.3138.056.0973.0373.1917.1016.283.193l3.7625 3.7624c.058.058.1015.1201.1305.1863a.522.522 0 01.0435.2115c0 .1493-.0528.2819-.1585.3978-.1057.116-.2434.1739-.4133.1739h-7.923z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
CaretUp.displayName = "CaretUpIcon";

export { CaretUp, CaretUp as default };
